import type { FC } from "react";

import type { PlanSnapshotNodeWithDependencyCounts } from "../../types";

import {
  AccentCard,
  CARD_DESC_CLASS,
  CARD_STATUS_CLASS,
  CARD_TITLE_CLASS,
  EmptyState,
  StatusDot,
  getStatusAccent,
  getStatusDot,
} from "../common";
import { SectionHeader } from "../common/SectionHeader";

export interface PlanSnapshotDrawerDependentsListProps {
  dependents: PlanSnapshotNodeWithDependencyCounts[];
  onSelectNode: (nodeId: string) => void;
}

export const PlanSnapshotDrawerDependentsList: FC<
  PlanSnapshotDrawerDependentsListProps
> = ({ dependents, onSelectNode }) => (
  <section>
    <SectionHeader
      variant="default"
      title="Dependents"
      badge={String(dependents.length)}
      className="mb-0 text-xs"
    />
    {dependents.length === 0 ? (
      <EmptyState
        size="sm"
        title="No dependents"
        description="No other tasks in this snapshot list this node as a dependency."
      />
    ) : (
      <div className="space-y-1">
        {dependents.map((dependent) => (
          <AccentCard
            key={dependent.node_id}
            accent={getStatusAccent(dependent.status)}
            onClick={() => onSelectNode(dependent.node_id)}
            title="Open dependent details"
          >
            <div className="flex items-center gap-1.5">
              <StatusDot color={getStatusDot(dependent.status)} />
              <span className={CARD_TITLE_CLASS}>{dependent.issue_key}</span>
              {dependent.status && (
                <span className={CARD_STATUS_CLASS}>{dependent.status}</span>
              )}
            </div>
            {(dependent.title ??
              dependent.humanized_description ??
              dependent.description) && (
              <p className={CARD_DESC_CLASS}>
                {dependent.title ??
                  dependent.humanized_description ??
                  dependent.description ??
                  "Untitled task"}
              </p>
            )}
          </AccentCard>
        ))}
      </div>
    )}
  </section>
);
